import { Cart } from '../types';
import { cartRequest } from './request';

/**
 * Takes a line out of the cart and answers the cart it produced.
 *
 * `itemId` is the line's own id — `CartItem.id`, the legacy `uniqueID` — not a product
 * or sku id. Two copies of one title are two lines with two ids, and removing "the
 * product" is not something the endpoint can be asked for.
 *
 * The endpoint does not 404 an id that is not there; it removes nothing and answers the
 * unchanged cart. A caller that has just been told the line is gone is therefore right
 * either way.
 */
export default async function removeItem(itemId: number): Promise<Cart> {
  return cartRequest(`/services_api/storefront/v1/cart/items/${itemId}.json`, { method: 'DELETE' });
}
